import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_35fe9e6e from 'nuxt_plugin_plugin_35fe9e6e' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_4b157a48 from 'nuxt_plugin_sentryserver_4b157a48' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_3547ee80 from 'nuxt_plugin_sentryclient_3547ee80' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_bootstrapvue_ff86ce9a from 'nuxt_plugin_bootstrapvue_ff86ce9a' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_distplugin278b540d_75ec9642 from 'nuxt_plugin_distplugin278b540d_75ec9642' // Source: ./dist.plugin.278b540d.js (mode: 'client')
import nuxt_plugin_workbox_246362a0 from 'nuxt_plugin_workbox_246362a0' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_9fffec9a from 'nuxt_plugin_metaplugin_9fffec9a' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_96b0a1b2 from 'nuxt_plugin_iconplugin_96b0a1b2' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_portalvue_6aae3f62 from 'nuxt_plugin_portalvue_6aae3f62' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_pluginclient_65e0fa2c from 'nuxt_plugin_pluginclient_65e0fa2c' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_32c8f472 from 'nuxt_plugin_pluginserver_32c8f472' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_axios_6eb87e84 from 'nuxt_plugin_axios_6eb87e84' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_fontawesome_08ce5ec6 from 'nuxt_plugin_fontawesome_08ce5ec6' // Source: ./fontawesome.js (mode: 'all')
import nuxt_plugin_mixins_5013a1f0 from 'nuxt_plugin_mixins_5013a1f0' // Source: ../../../plugins/mixins (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../../../plugins/axios (mode: 'all')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4' // Source: ../../../plugins/api (mode: 'all')
import nuxt_plugin_try_5e466a85 from 'nuxt_plugin_try_5e466a85' // Source: ../../../plugins/try (mode: 'all')
import nuxt_plugin_routerx_39668619 from 'nuxt_plugin_routerx_39668619' // Source: ../../../plugins/routerx (mode: 'client')
import nuxt_plugin_nuxtclientinit_181bd504 from 'nuxt_plugin_nuxtclientinit_181bd504' // Source: ../../../plugins/nuxt-client-init (mode: 'client')
import nuxt_plugin_survey_3a4c5b60 from 'nuxt_plugin_survey_3a4c5b60' // Source: ../../../plugins/survey (mode: 'client')
import nuxt_plugin_extras_69bdcd4e from 'nuxt_plugin_extras_69bdcd4e' // Source: ../../../plugins/extras (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"MC","meta":[{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"},{"name":"msapplication-TileColor","content":"#008ccd"},{"name":"theme-color","content":"#008ccd"}],"link":[],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_35fe9e6e === 'function') {
    await nuxt_plugin_plugin_35fe9e6e(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_4b157a48 === 'function') {
    await nuxt_plugin_sentryserver_4b157a48(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_3547ee80 === 'function') {
    await nuxt_plugin_sentryclient_3547ee80(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_ff86ce9a === 'function') {
    await nuxt_plugin_bootstrapvue_ff86ce9a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_distplugin278b540d_75ec9642 === 'function') {
    await nuxt_plugin_distplugin278b540d_75ec9642(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_246362a0 === 'function') {
    await nuxt_plugin_workbox_246362a0(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_9fffec9a === 'function') {
    await nuxt_plugin_metaplugin_9fffec9a(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_96b0a1b2 === 'function') {
    await nuxt_plugin_iconplugin_96b0a1b2(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_6aae3f62 === 'function') {
    await nuxt_plugin_portalvue_6aae3f62(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_65e0fa2c === 'function') {
    await nuxt_plugin_pluginclient_65e0fa2c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_32c8f472 === 'function') {
    await nuxt_plugin_pluginserver_32c8f472(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_6eb87e84 === 'function') {
    await nuxt_plugin_axios_6eb87e84(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_08ce5ec6 === 'function') {
    await nuxt_plugin_fontawesome_08ce5ec6(app.context, inject)
  }

  if (typeof nuxt_plugin_mixins_5013a1f0 === 'function') {
    await nuxt_plugin_mixins_5013a1f0(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_api_5e4622e4 === 'function') {
    await nuxt_plugin_api_5e4622e4(app.context, inject)
  }

  if (typeof nuxt_plugin_try_5e466a85 === 'function') {
    await nuxt_plugin_try_5e466a85(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_routerx_39668619 === 'function') {
    await nuxt_plugin_routerx_39668619(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtclientinit_181bd504 === 'function') {
    await nuxt_plugin_nuxtclientinit_181bd504(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_survey_3a4c5b60 === 'function') {
    await nuxt_plugin_survey_3a4c5b60(app.context, inject)
  }

  if (typeof nuxt_plugin_extras_69bdcd4e === 'function') {
    await nuxt_plugin_extras_69bdcd4e(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
